import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InboundEmailsComponent } from './inbound-emails.component';

const routes: Routes = [{ path: '', component: InboundEmailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InboundEmailsRoutingModule { }
